export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const GET_USERS = 'GET_USERS';
export const GET_USER = 'GET_USER';
export const SET_CURRENT = 'SET_CURRENT';

export const GET_POSTS = 'GET_POSTS';
export const GET_POST = 'GET_POST';
export const GET_RELATEDPOSTS = 'GET_RELATEDPOSTS';
export const UPDATE_POST = 'UPDATE_POST';
export const GET_POSTDETAILS = 'GET_POSTDETAILS';
export const GET_RECENTPOSTS = 'GET_RECENTPOSTS';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_SIMILARPOSTS = 'GET_SIMILARPOSTS';
export const GET_ADJACENTPOSTS = 'GET_ADJACENTPOSTS';
export const GET_CATEGORYPOST = 'GET_CATEGORYPOST';
export const GET_FEATUREDPOSTS = 'GET_FEATUREDPOSTS';
export const GET_COMMENTS = 'GET_COMMENTS';
export const SUBMITCOMMENT = 'SUBMITCOMMENT';
export const FILTER_POSTS = 'FILTER_POSTS';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const CLEAR_CURRENT = 'CLEAR_CURRENT';
export const CLEAR_POSTS = 'CLEAR_POSTS';
export const POST_ERROR = 'POST_ERROR';

export const GET_JOBS = 'GET_JOBS';
export const GET_JOB = 'GET_JOB';
export const UPDATE_JOB = 'UPDATE_JOB';
export const GET_JOBDETAILS = 'GET_JOBDETAILS';
export const GET_RECENTJOBS = 'GET_RECENTJOBS';
export const GET_SIMILARJOBS = 'GET_SIMILARJOBS';
export const GET_ADJACENTJOBS = 'GET_ADJACENTJOBS';
export const GET_CATEGORYJOB = 'GET_CATEGORYJOB';
export const GET_FEATUREDJOBS = 'GET_FEATUREDJOBS';
export const FILTER_JOBS = 'FILTER_JOBS';
export const CLEAR_JOBS = 'CLEAR_JOBS';
export const JOB_ERROR = 'JOB_ERROR';


export const GET_INTERNSHIPS = 'GET_INTERNSHIPS';
export const GET_INTERNSHIP = 'GET_INTERNSHIP';
export const UPDATE_INTERNSHIP = 'UPDATE_INTERNSHIP';
export const GET_INTERNSHIPDETAILS = 'GET_INTERNSHIPDETAILS';
export const GET_RECENTINTERNSHIPS = 'GET_RECENTINTERNSHIPS';
export const GET_SIMILARINTERNSHIPS = 'GET_SIMILARINTERNSHIPS';
export const GET_ADJACENTINTERNSHIPS = 'GET_ADJACENTINTERNSHIPS';
export const GET_CATEGORYINTERNSHIP = 'GET_CATEGORYINTERNSHIP';
export const GET_FEATUREDINTERNSHIPS = 'GET_FEATUREDINTERNSHIPS';
export const FILTER_INTERNSHIPS = 'FILTER_INTERNSHIPS';
export const CLEAR_INTERNSHIPS = 'CLEAR_INTERNSHIPS';
export const INTERNSHIP_ERROR = 'POST_ERROR';
